import { Component, OnInit, Input } from '@angular/core';
import { ICommerceConfig } from '../../../models/Commerce';
@Component({
  selector: 'app-credentials',
  templateUrl: './credentials.component.html',
  styleUrls: ['./credentials.component.scss'],
})
export class CredentialsComponent implements OnInit {
  @Input() credentials: ICommerceConfig;
  @Input() isVtex?: boolean = false;

  successApiKeyCopy: boolean;
  successApiSecretCopy: boolean;
  successAppKeyCopy: boolean;
  successAppTokenCopy: boolean;
  hideApiSecret = true;

  constructor() {}

  ngOnInit(): void {}

  copyToClipboard(typeKey: string) {
    if (typeKey === 'public') {
      this.successApiKeyCopy = true;
    } else if (typeKey === 'secret') {
      this.successApiSecretCopy = true;
    }else if(typeKey === 'appKey'){
      this.successAppKeyCopy = true;
    }else if(typeKey === 'appToken'){
      this.successAppTokenCopy = true;
    }
    const options = {
      public: this.credentials.apiKey,
      secret: this.credentials.webhookSecret,
      appKey: this.credentials.integrations.vtex.appKey,
      appToken: this.credentials.integrations.vtex.appToken
    }
    window.navigator.clipboard.writeText(
      options[typeKey],
    );
    setTimeout(() => {
      this.successApiKeyCopy = false;
      this.successApiSecretCopy = false;
      this.successAppKeyCopy = false;
      this.successAppTokenCopy = false;
    }, 2000);
  }
}
